import { useRecordContext } from 'react-admin';
import { ProductType } from '../types';

export const ProductTypeTitle = () => {
  const record = useRecordContext<ProductType>();
  return <span>Product Type: {record ? `${record.id}` : ''}</span>;
};
